import { getDocumentBlocks, getInlineParts, getReportParagraphs, isAmountColumn } from "./documentLayout";

export function printLetterContent(content, title = "Medical Necessity Letter", { tables = false } = {}) {
  const printWindow = window.open("", "_blank");
  if (!printWindow) {
    throw new Error("Could not open the print view. Allow pop-ups for this site and try again.");
  }
  printWindow.opener = null;
  const printDocument = printWindow.document;
  printDocument.title = title;
  const style = printDocument.createElement("style");
  style.textContent = `
    body { margin: 0; color: #000; background: #fff; }
    pre { margin: 0; white-space: pre-wrap; overflow-wrap: anywhere;
      font: 12pt/1.5 Georgia, serif; }
    .report { font: 11pt/1.65 Arial, sans-serif; }
    .report p { margin: 0 0 16px; white-space: pre-wrap; overflow-wrap: anywhere; }
    .report h2, .report h3, .report h4 { margin: 24px 0 12px; line-height: 1.4; break-after: avoid; }
    .report h2 { font-size: 16pt; } .report h3 { font-size: 14pt; } .report h4 { font-size: 12pt; }
    table { width: 100%; margin: 20px 0 28px; border-collapse: collapse; font: 10pt/1.5 Arial, sans-serif; }
    th, td { border: 0; border-bottom: 1px solid #ddd; padding: 10px 8px; text-align: left; vertical-align: top; overflow-wrap: anywhere; }
    th { border-bottom: 1px solid #999; } .amount { text-align: right; font-variant-numeric: tabular-nums; }
    thead { display: table-header-group; }
    tr { break-inside: avoid; }
    @page { margin: 0.75in; }
    @media screen { body { max-width: 8in; margin: 2rem auto; padding: 1rem; } }
  `;
  const letter = printDocument.createElement(tables ? "div" : "pre");
  if (tables) {
    letter.className = "report";
    const appendInline = (element, text) => {
      for (const part of getInlineParts(text)) {
        if (part.strong) {
          const strong = printDocument.createElement("strong");
          strong.textContent = part.text;
          element.appendChild(strong);
        } else {
          element.appendChild(printDocument.createTextNode(part.text));
        }
      }
    };
    for (const block of getDocumentBlocks(content)) {
      if (block.text !== undefined) {
        for (const paragraph of getReportParagraphs(block.text)) {
          const text = printDocument.createElement(paragraph.heading ? `h${Math.min(6, paragraph.heading + 1)}` : "p");
          appendInline(text, paragraph.text);
          letter.appendChild(text);
        }
      } else {
        const table = printDocument.createElement("table");
        const head = table.createTHead().insertRow();
        for (const value of block.headers) {
          const cell = printDocument.createElement("th");
          cell.scope = "col";
          if (isAmountColumn(value)) cell.className = "amount";
          appendInline(cell, value);
          head.appendChild(cell);
        }
        const body = table.createTBody();
        for (const values of block.rows) {
          const row = body.insertRow();
          values.forEach((value, column) => {
            const cell = row.insertCell();
            if (isAmountColumn(block.headers[column])) cell.className = "amount";
            appendInline(cell, value);
          });
        }
        letter.appendChild(table);
      }
    }
  } else {
    letter.textContent = String(content);
  }
  printDocument.head.appendChild(style);
  printDocument.body.replaceChildren(letter);
  printWindow.focus();
  printWindow.print();
}
